import { Component, Input } from '@angular/core';
import { SystemUpdate } from '../../interfaces/system-update';

@Component({
    selector: 'app-system-updates',
    templateUrl: './system-updates.component.html',
    styleUrls: ['./system-updates.component.scss'],
    standalone: false
})
export class SystemUpdatesComponent {
  @Input()
  public systemUpdates!: SystemUpdate[];
  @Input()
  public borderTop!: boolean;

  onClick(systemUpdate: SystemUpdate): void {
    systemUpdate.read = true;
  }
}
